import { useQuery } from "@tanstack/react-query";
import { getPatchNotes, getSearch } from "../api";

export const useGetPatchNotes = () => {
  const { data, isLoading, status, isError, error, isSuccess } = useQuery({
    queryKey: ["patch-notes"],
    queryFn: () => getPatchNotes(),
  });

  return {
    data,
    status,
    isLoading,
    isError,
    error,
    isSuccess,
  };
};


export const useGetSearch = (search) => {
  const { data, isLoading, status, isError, error, isSuccess } = useQuery({
    queryKey: ["search", search],
    queryFn: () => getSearch(search),
    enabled: Boolean(search && String(search).trim().length > 0),
    keepPreviousData: true,
  });

  return {
    data,
    status,
    isLoading,
    isError,
    error,
    isSuccess,
  };
};



